import React, { useState } from "react";
import banner from "./image/JujharMotorBanner.png";
import { Footer } from "./Footer";
import { Navbar } from "./Navbar";
import logo2 from "./image/JujharMotorss.png";
import dots from "./image/icons.webp";
import icon1 from "./image/Maternal.webp";
import icon2 from "./image/Gynaecology.webp";
import icon3 from "./image/Fetal.webp";
import icon4 from "./image/Neonatology.webp";
import dot_left from "./image/icons.webp";
import { NavLink } from "react-router-dom";
import { Helmet } from "react-helmet";

export const Jujharmotors = () => {
  const [state, setState] = useState({ var1: 1, var2: 1 });
  return (
    <>
      <Helmet>
        <title>Jujhar Motors</title>
        <meta
          name="description"
          content="The Jujhar Group, a Ludhiana-based company with diversified business interests, has forayed into the hospitality sector by acquiring the Fairfield by Marriott Hotel Amritsar."
        />
      </Helmet>
      <Navbar />
      <section id="banner" className="p-0 textcenter">
        <div
          className="banner hospitality"
          style={{ backgroundImage: `url(${banner})` }}
        >
          <div className="container">
            <div className="row">
              <div className="bannercont pulll-center">
                <h2>
                  <span>
                    {/* Driven by <em>innovation</em>, Delivered with care. */}
                  </span>
                </h2>
                <div className="backbtns">
                  <NavLink className="btn-3" to="/businesses">
                    <span>
                      <i className="backarrow"></i>Go Back
                    </span>
                  </NavLink>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section id="breadcrum" className="p-0">
        <div className="breadcrum">
          <div className="container">
            <div className="row">
              <div className="web-container">
                <ul className="d-flex">
                  <li>
                    <NavLink to="/about-us">About</NavLink>
                  </li>
                  <li>
                    <NavLink to="/businesses">Our BUSINESSES</NavLink>
                  </li>
                  <li>Jujhar Motors</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section id="entertainement">
        <div className="container">
          <div className="row">
            <div className="web-container">
              <div
                className="dot-img position-absolute slow-move-anticlockwise"
                data-aos="fade-up"
                data-aos-offset="200"
                data-aos-ea
                sing="ease-in-sine"
                data-aos-duration="600"
                data-aos-once="true"
              >
                <img
                  src={dots}
                  title="Jujhar Group"
                  alt="Jujhar Group"
                  width="542"
                  height="525"
                />
              </div>
              <div className="overview">
                <div className="row">
                  <div className="col-md-4 col-xs-12">
                    <div className="entertainmentlogo">
                      <img
                        src={logo2}
                        alt="Hospitality"
                        title="Hospitality"
                        width="200"
                        height="200"
                      />
                    </div>
                  </div>
                  <div className="col-md-8 col-xs-12">
                    <div className="entertainmentdtl">
                      <h1>Jujhar Motors</h1>
                      <p>
                        Jujhar Group is a trusted and professionally managed
                        business group committed to excellence, integrity, and
                        customer satisfaction. With a strong presence in the
                        automobile sector, we proudly operate a Maruti Suzuki
                        Arena showroom at Samrala Chowk, Ludhiana, offering
                        world-class sales and service solutions.
                      </p>
                      <p>
                        Our modern showroom is equipped with advanced
                        infrastructure and a skilled team to ensure a seamless
                        and transparent car-buying experience. From product
                        consultation and test drives to finance, insurance, and
                        after-sales support, we provide complete mobility
                        solutions under one roof.
                      </p>
                      <p>
                        Driven by a customer-first approach and strong ethical
                        values, Jujhar Group continues to build long-term
                        relationships and deliver superior value to every
                        customer.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section id="service">
        <div className="service">
          <div className="container">
            <div className="web-container">
              <div className="dot-img-left position-absolute slow-move-anticlockwise">
                <img
                  src={dot_left}
                  title="Jujhar Group"
                  alt="Jujhar Group"
                  width="542"
                  height="525"
                />
              </div>
            </div>
          </div>
        </div>
      </section>
      <section id="businessbtn">
        <div className="businessbtn">
          <div className="container">
            <div className="web">
              <div class="backbtn text-center">
                <NavLink className="btn-3" to="/businesses">
                  <span>
                    <i className="backarrow"></i>Jujhar Businessess
                  </span>
                </NavLink>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </>
  );
};
